import React, {useEffect,useState,Suspense} from 'react';
import AdminServiciosAPI from '../servicios/AdminServicios';
import { BlockUI } from 'primereact/blockui';
import './revista.css'

const RevistaImagen = React.lazy(() => import('./RevistaImagen'));
const RevistaPdf = React.lazy(() => import('./RevistaPdf'));

const Revista = () => {  
    const [cargando, setCargando] = useState(false);
    const [datos, setDatos] = useState(null);
    
    const cargarDatos = async() => {
        const urlParams = new URLSearchParams(window.location.search)
        const id = urlParams.get('id')

        if(id  && id!==''){
            setCargando(true)
            const response = await AdminServiciosAPI.getRegistro(`consultarchivos/${id}`);
            if (response) {
                const respuesta = await response.json();
                //console.log('datos',respuesta.datos)
                if(respuesta.datos && respuesta.datos.codigo){
                    document.title = respuesta.datos.nombre
                    setDatos(respuesta.datos)
                }
            }
            setCargando(false)
        }
    }

    useEffect(() => {
        cargarDatos();
    },[])

    const VerRevista = () => {
        if(datos.datos.nombrearchivo.length>1){
            return <Suspense fallback={<div>...</div>}>
            <RevistaImagen datos={datos}/>
        </Suspense>
        }else {
            return <Suspense fallback={<div>...</div>}>
            <RevistaPdf datos={datos}/>
        </Suspense>
        }
    }

    return (
        <BlockUI blocked={cargando}>
        <div className="bg-gray-900 h-screen d-flex flex-column justify-content-center overflow-hidden">
            {datos && <VerRevista />}
        </div>
        </BlockUI>
    )
}

export default Revista 